import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";


import MapStyle from "assets/jss/material-kit-react/views/landingPageSections/MapStyle.jsx";

//<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3817.7449853822027!2d96.110232!3d16.888505000000002!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x26243a7682e95fd1!2sMyanmar+Gateway+Engineering+and+Consultancy!5e0!3m2!1sen!2smm!4v1547279857171" width="800" height="600" frameborder="0" style="border:0" allowfullscreen></iframe>
class MapSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div>
        <h3 className={classes.title}></h3>
       <div className={classes.mapres}>
      <iframe
 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d954.4361350851707!2d96.10968282914489!3d16.888526999273722!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x26243a7682e95fd1!2sMyanmar+Gateway+Engineering+and+Consultancy!5e0!3m2!1sen!2smm!4v1547273640083"
 className={classes.maps}
 ></iframe>
 	</div>
  </div>
    );
  }
}

export default withStyles(MapStyle)(MapSection);



// WEBPACK FOOTER //
// ./src/views/ContactPage/Sections/MapSection.jsx